// extracted by mini-css-extract-plugin
export default {"nextBtn":"nextExampleButton_nextBtn__dXBfn"};